import { css } from '@emotion/react'
import { Button, Card, Flow, Heading, Icon, Status, Text, Theme, useTheme } from 'bold-ui'

interface IntegracaoRegulacaoCardProps {
  onAdicionarSolicitacao: () => void
  dataTestId?: string
}

export function IntegracaoRegulacaoCard(props: Readonly<IntegracaoRegulacaoCardProps>) {
  const { onAdicionarSolicitacao: adicionarSolicitacao, dataTestId } = props
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Card variant='outline' style={styles.card} data-testid={dataTestId}>
      <Flow direction='horizontal' alignItems='center' justifyContent='space-between'>
        <Flow direction='vertical' gap={0.5}>
          <Flow direction='vertical' gap={0.25}>
            <Heading level={4}>Solicitar via integração com e-SUS Regulação</Heading>
            <Text>Envio automático ao e-SUS Regulação e acompanhamento pelo Prontuário e-SUS APS.</Text>
          </Flow>
          <Status type='success' text='Integração disponível' />
        </Flow>

        <Button kind='primary' size='small' onClick={adicionarSolicitacao}>
          <Icon icon='plus' style={{ marginRight: '0.5rem' }} />
          Adicionar solicitação
        </Button>
      </Flow>
    </Card>
  )
}

const createStyles = (theme: Theme) => ({
  card: css`
    background: ${theme.pallete.gray.c90};
  `,
})
